<app-preloader *ngIf="settings.isShowingLoader()"></app-preloader>
<div class="chart-banner"></div>
<div class="chart-background pt-70 pb-70">
  <div class="container">
    <div class="section-title">
      <h2>Benvenuto nel mondo di <span>Hit-fluencer</span></h2>
      <p>E' necessario loggarsi per proseguire. Inserisci il nome utente e password per scoprirci!</p>
    </div>
    <div class="row align-items-center">
      <div class="contact-form">
        <form #loginForm="ngForm" (ngSubmit)="submitForm(loginForm.value)">
          <div class="row">
            <div class="col-lg-4 col-md-6">
              <div class="form-group mb-3">
                <h5 class="pb-2">Nome utente</h5>
                <input #username="ngModel"
                       type="text"
                       class="form-control"
                       id="username"
                       name="username"
                       ngModel
                       required>
                <div
                  *ngIf="username.touched && !username.valid && (username.errors && username.errors.required)"
                  class="alert alert-danger">
                  E' necessario inserire un nome utente!
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6">
              <div class="form-group mb-3">
                <h5 class="pb-2">Password</h5>
                <input #password="ngModel"
                       type="password"
                        class="form-control"
                        id="password"
                        name="password"
                        ngModel
                        required>
                <div
                  *ngIf="password.touched && !password.valid && (password.errors && password.errors.required)"
                  class="alert alert-danger">
                  E' necessario inserire una password!
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-12 pt-2">
              <button [disabled]="!loginForm.valid"
                      class="btn btn-primary float-end"
                      type="submit">Accedi
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
